import { render, staticRenderFns } from "./ApplicationPriorityBadge.vue?vue&type=template&id=fe0a53ae"
import script from "./ApplicationPriorityBadge.vue?vue&type=script&lang=js"
export * from "./ApplicationPriorityBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports